import { useShellStore } from '@store/shell';

/**
 * Returns true when the pathname is the settings view (not a chat URL).
 */
export function isSettingsPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/$/, '') || '/';
  if (normalized.includes('/chat/')) {
    return false;
  }
  return normalized === '/settings' || normalized.endsWith('/settings');
}

export function syncBrowserPathname(): void {
  useShellStore.getState().setBrowserPathname(window.location.pathname);
}

/**
 * Updates the URL with {@link history.pushState} and syncs shell
 * `browserPathname` so React re-renders match the address bar.
 */
export function pushPath(url: string): void {
  window.history.pushState(null, '', url);
  syncBrowserPathname();
}

/**
 * Updates the URL with {@link history.replaceState} and syncs shell
 * `browserPathname`.
 */
export function replacePath(url: string): void {
  window.history.replaceState(null, '', url);
  syncBrowserPathname();
}
